<ng-container *ngIf="isDiagnosticsAvailable; else notAvailable">
  <app-pill
    *ngIf="remoteDiagnosticsStore.isDiagnosticsSessionRunning(gatewaySerial) | async"
    [type]="pillType.secondary"
  >
    {{ '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_OVERLAY.DIAGNOSTICS.RUNNING' | translate }}
  </app-pill>

  <app-pill
    *ngIf="remoteDiagnosticsStore.isDiagnosticsSessionInactive(gatewaySerial) | async"
    [type]="pillType.secondary"
  >
    {{ '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_OVERLAY.CONNECTION.INACTIVE' | translate }}
  </app-pill>

  <app-pill
    *ngIf="connectionStatus === diagnosticsConnectionStatus.ACTIVE"
    [type]="pillType.success"
  >
    {{ '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_OVERLAY.CONNECTION.ACTIVE' | translate }}
  </app-pill>

  <app-pill *ngIf="connectionStatus === diagnosticsConnectionStatus.FAILED" [type]="pillType.error">
    {{ '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_OVERLAY.CONNECTION.FAILED' | translate }}
  </app-pill>

  <app-pill
    *ngIf="connectionStatus === diagnosticsConnectionStatus.LOADING"
    [type]="pillType.medium"
  >
    {{ '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_OVERLAY.CONNECTION.LOADING' | translate }}
  </app-pill>
</ng-container>

<ng-template #notAvailable>
  <div class="flex flex-row gap-[8px]">
    <app-pill *ngIf="devicePlatform === platform.Legacy" [type]="pillType.secondary">
      {{ '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_OVERLAY.DIAGNOSTICS.NOT_SUPPORTED' | translate }}
    </app-pill>

    <ng-container *appHideForRsaUser>
      <app-pill
        *ngIf="
          (remoteConfigStore.hasAccessToProPlusFeaturesByVkOrg$ | async) &&
          installationPackage === bookingPlans.Basic
        "
        [type]="pillType.secondary"
      >
        {{
          '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_OVERLAY.DIAGNOSTICS.UPGRADE_REQUIRED' | translate
        }}
      </app-pill>
    </ng-container>

    <ng-container *appShowForRsaUser>
      <app-pill
        *ngIf="
          (installationDetailsStore.getGatewayStatus(gatewaySerial) | async).remoteDiagnostic;
          else inactive
        "
        [type]="pillType.secondary"
      >
        {{ '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_OVERLAY.DIAGNOSTICS.RUNNING' | translate }}
      </app-pill>

      <ng-template #inactive>
        <app-pill [type]="pillType.secondary">
          {{ '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_OVERLAY.CONNECTION.INACTIVE' | translate }}
        </app-pill>
      </ng-template>
    </ng-container>
  </div>
</ng-template>
